const moduleName = '.resourceNotificaions'
import qs from 'qs'
import { mediumFullUrl } from '../helpers/commons.helper'

export default ({ clientWrapper, context, repository }) => ({
  create: (resourceNotification) => {
    context.lastApiPath = `${moduleName}.create`
    return clientWrapper.api.post('resource_notifications', resourceNotification)
  },

  recipients: () => {
    context.lastApiPath = `${moduleName}.recipients`
    return clientWrapper.api.get('resource_notifications/recipients')
  },

  search: (page, filters) => {
    context.lastApiPath = `${moduleName}.all`
    let params = { page }
    if (filters) {
      params.q = { ...filters }
    }

    return clientWrapper.api.get('resource_notifications/search', { params, paramsSerializer: qs.stringify })
      .then(response => ({
        ...response,
        items: response.items.map(resourceNotification => ({
          ...resourceNotification,
          images: resourceNotification.images.map(medium => mediumFullUrl(repository, medium))
        }))
      }))
  }
})
